module.exports = __webpack_public_path__ + "site/img/69.8fdc91fc.jpg";